// components/ui/table.jsx
import * as React from "react";

// 간단한 className 머지 유틸 (shadcn의 cn 대체)
function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const Table = React.forwardRef(function Table(
  { className, ...props },
  ref
) {
  return (
    <div className="w-full overflow-x-auto">
      <table
        ref={ref}
        className={cn("w-full caption-bottom text-sm", className)}
        {...props}
      />
    </div>
  );
});

export const TableHeader = React.forwardRef(function TableHeader(
  { className, ...props },
  ref
) {
  return (
    <thead
      ref={ref}
      className={cn("[&_tr]:border-b", className)}
      {...props}
    />
  );
});

export const TableBody = React.forwardRef(function TableBody(
  { className, ...props },
  ref
) {
  return (
    <tbody
      ref={ref}
      className={cn("[&_tr:last-child]:border-0", className)}
      {...props}
    />
  );
});

export const TableFooter = React.forwardRef(function TableFooter(
  { className, ...props },
  ref
) {
  return (
    <tfoot
      ref={ref}
      className={cn("bg-slate-900 font-medium text-slate-50", className)}
      {...props}
    />
  );
});

export const TableRow = React.forwardRef(function TableRow(
  { className, ...props },
  ref
) {
  return (
    <tr
      ref={ref}
      className={cn(
        "border-b border-zinc-800 transition-colors data-[state=selected]:bg-zinc-800/50",
        className
      )}
      {...props} // ✅ onClick, onMouseEnter 등 모두 전달
    />
  );
});

export const TableHead = React.forwardRef(function TableHead(
  { className, ...props },
  ref
) {
  return (
    <th
      ref={ref}
      className={cn(
        "h-10 px-4 text-left align-middle font-medium text-zinc-400",
        className
      )}
      {...props} // ✅ 클릭 정렬용 onClick 전달
    />
  );
});

export const TableCell = React.forwardRef(function TableCell(
  { className, ...props },
  ref
) {
  return (
    <td
      ref={ref}
      className={cn("p-4 align-middle", className)}
      {...props} // ✅ 개별 셀 이벤트도 전달
    />
  );
});

export const TableCaption = React.forwardRef(function TableCaption(
  { className, ...props },
  ref
) {
  return (
    <caption
      ref={ref}
      className={cn("mt-4 text-sm text-zinc-500", className)}
      {...props}
    />
  );
});